var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4194",
    "data-name": "Group 4194",
    transform: "translate(-383 -90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 22,
    height: 22,
    transform: "translate(383 90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(387.577 94.576)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(0.423 0.423)",
    fill: "none",
    stroke: "#a6a8bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 3,
    y1: 3,
    transform: "translate(8.923 8.924)",
    fill: "none",
    stroke: "#a6a8bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridSearchIcon);
export default __webpack_public_path__ + "static/media/grid-search-icon.26d6bb200d4740fd4b5ec7ac5a5bbeca.svg";
export { ForwardRef as ReactComponent };